module.exports = __webpack_public_path__ + "static/media/vase1.1d1736b8.jpg";